import { render } from "./SpecsIcon.vue?vue&type=template&id=54432b97"
import script from "./SpecsIcon.vue?vue&type=script&lang=js"
export * from "./SpecsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__